import { useState, useEffect } from 'react'
import { formatTime } from '../../lib/utils'

interface TimerProps {
  elapsed: number
  isActive: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Timer({
  elapsed,
  isActive,
  size = 'md',
  className = '',
}: TimerProps) {
  const [displayTime, setDisplayTime] = useState(elapsed)

  useEffect(() => {
    if (!isActive) {
      setDisplayTime(elapsed)
      return
    }

    const interval = setInterval(() => {
      setDisplayTime((prev) => prev + 10)
    }, 10)

    return () => clearInterval(interval)
  }, [isActive, elapsed])

  const sizeClasses = {
    sm: 'text-2xl',
    md: 'text-4xl',
    lg: 'text-6xl',
  }

  return (
    <div className={`font-fredoka font-700 text-glow ${sizeClasses[size]} ${className}`}>
      {formatTime(displayTime)}
    </div>
  )
}
